import Modal from 'flarum/common/components/Modal';
import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import StoreItem from '../../common/models/StoreItem';
import { showIf } from '../utils/NodeUtil';
import StoreItemComponent from '../components/StoreItemComponent';
import PurchaseHistoryComponent from '../components/PurchaseHistoryComponent';
export default class QueryModal extends Modal {
  selected = 0;
  className() {
    return 'Modal--small';
  }
  title() {
    const attrs = this.attrs;
    if (!attrs.items?.length) return "";
    if (attrs.items[0] instanceof StoreItem) return app.translator.trans('xypp-store.forum.query-modal.purchase.title');
    return app.translator.trans('xypp-store.forum.query-modal.use.title');
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.selected = 0;
  }
  content() {
    const attrs = this.attrs;
    if (!attrs.items?.length) {
      return "";
    }
    return m("div", {
      className: "Modal-body"
    }, m("div", {
      className: "query-body"
    }, showIf(!!attrs.items, attrs.items && showIf(!!(attrs.items[this.selected] instanceof StoreItem), m(StoreItemComponent, {
      noEdit: true,
      onBuy: this.onsubmit.bind(this),
      item: attrs.items[this.selected]
    }), m(PurchaseHistoryComponent, {
      alwaysShowBtn: true,
      noDelete: true,
      onUse: this.onsubmit.bind(this),
      item: attrs.items[this.selected]
    })))), m("div", {
      className: "query-control"
    }, m(Button, {
      class: "query-control-prev Button Button--primary",
      onclick: this.prev.bind(this)
    }, m("i", {
      class: "fas fa-chevron-left"
    })), m("span", null, this.selected + 1, "/", attrs.items?.length), m(Button, {
      class: "query-control-after Button Button--primary",
      onclick: this.next.bind(this)
    }, m("i", {
      class: "fas fa-chevron-right"
    }))));
  }
  prev() {
    if (this.selected > 0) {
      this.selected--;
      m.redraw();
    }
  }
  next() {
    const attrs = this.attrs;
    if (attrs.items && this.selected < attrs.items.length - 1) {
      this.selected++;
      m.redraw();
    }
  }
  onsubmit() {
    const attrs = this.attrs;
    if (attrs.on_submit && attrs.items) attrs.on_submit(attrs.items[this.selected]);
    app.modal.close();
  }
  onremove() {
    const attrs = this.attrs;
    if (attrs.on_close) attrs.on_close();
  }
}
flarum.reg.add('xypp-store', 'forum/components/QueryModal', QueryModal);